export const internalMediaPrimaryButtonClass =
    "inline-block self-start rounded-lg bg-[#2b528d] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#234472] hover:scale-[1.02] disabled:opacity-50 disabled:hover:scale-100";
